import React from "react";
import site from "../content/site.json";
import home from "../content/home.json";

const HeroSection = () => {
  const { brand } = site;
  const { hero } = home;

  return (
    <section
      data-testid="hero-section"
      className="relative pt-24 md:pt-28 pb-16 md:pb-20 bg-ivory tex-grain overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-center">
          {/* Text */}
          <div className="md:col-span-5 fade-up-stagger">
            {/* Full logo placeholder + TATTVAM title */}
            <div data-testid="hero-logo-wrap">
              <img
                src={brand.logoFull}
                alt={brand.logoFullAlt}
                data-testid="hero-logo-full"
                className="w-full max-w-[360px] h-auto"
              />
            </div>

            <h1
              data-testid="hero-subtitle"
              className="mt-10 font-heading text-2xl md:text-3xl text-charcoal font-normal leading-snug"
            >
              {hero.subtitle}
            </h1>

            <div className="mt-6 flex items-center gap-4">
              <span className="divider-gold" />
              <p
                data-testid="hero-tagline"
                className="font-heading italic text-xl md:text-2xl text-charcoal"
              >
                {hero.tagline}
              </p>
            </div>

            <p className="mt-10 max-w-md text-charcoal-soft leading-relaxed text-base md:text-lg">
              {hero.description}
            </p>

            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <a
                href={hero.primaryCta.href}
                data-testid="hero-cta-featured"
                className="inline-block bg-charcoal text-white px-8 py-4 text-xs tracking-[0.24em] uppercase font-semibold hover:bg-muted_gold transition-colors duration-500"
              >
                {hero.primaryCta.label}
              </a>
              <a
                href={hero.secondaryCta.href}
                data-testid="hero-cta-philosophy"
                className="inline-block border border-charcoal/40 text-charcoal px-8 py-4 text-xs tracking-[0.24em] uppercase font-medium hover:border-charcoal transition-colors duration-500"
              >
                {hero.secondaryCta.label}
              </a>
            </div>
          </div>

          {/* Placeholder hero artwork */}
          <div className="md:col-span-7">
            <div
              data-testid="hero-frame"
              className="relative mx-auto max-w-xl aspect-square hero-frame border border-charcoal/10"
            >
              <img
                src={hero.placeholderImage}
                alt={hero.placeholderImageAlt}
                data-testid="hero-placeholder-image"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
